"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var BootstrapHelper_1 = require("../..//BootstrapHelper");
var enums_1 = require("../../enums");
var ButtonGroup = function (props) {
    var cls = (0, BootstrapHelper_1.B)()
        .bl("btn-group".concat(props.isVertical ? "--vertical" : ""))
        .pmod(props.size || enums_1.UiSizes.MD)
        .pmod(props.isToggle ? "toggle" : "").bem;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat(cls, " ").concat(props.className || ""), role: "group" }, { children: props.children })));
};
exports.ButtonGroup = ButtonGroup;
